import { render, staticRenderFns } from "./BidSide.vue?vue&type=template&id=1d6fbfa6&"
import script from "./BidSide.vue?vue&type=script&lang=js&"
export * from "./BidSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports